import classnames from "classnames";
import PropTypes from "prop-types";
import React from "react";
// eslint-disable-next-line css-modules/no-unused-class
import styles from "./button.css";

const STYLE_TYPE_CLASSES = {
    primary: styles.primary,
    secondary: styles.secondary,
    tertiary: styles.tertiary,
    "temp-grey": styles.tempGrey
};

function disabledCB(event) {
    event.preventDefault();
}

function Button({ className, element, fullHeight, fullWidth, openInNewTab, styleType, ...props }) {
    let Component = props.href ? "a" : "button";
    if (element) {
        Component = element;
    }
    const typeClass = STYLE_TYPE_CLASSES[styleType];
    if (!typeClass) {
        throw new Error(`Unknown type ${styleType}!`);
    }
    props.className = classnames(className, styles.button, typeClass, {
        [styles.fullWidth]: fullWidth,
        [styles.fullHeight]: fullHeight,
        [styles.disabled]: props.disabled
    });

    if (props.href) {
        props.target = openInNewTab ? "_blank" : "_self";
    }
    if (props.disabled) {
        props.onClick = disabledCB;
    }

    return <Component {...props} />;
}

export default Button;

Button.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    element: PropTypes.oneOf(["a", "button", "span"]),
    disabled: PropTypes.bool,
    fullWidth: PropTypes.bool,
    fullHeight: PropTypes.bool,
    href: PropTypes.string,
    onClick: PropTypes.func,
    openInNewTab: PropTypes.bool,
    styleType: PropTypes.oneOf(["primary", "secondary", "tertiary", "temp-grey"]).isRequired
};
